var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "401.149px",
    viewBox: "0 0 1000 401.149",
    enableBackground: "new 0 0 1000 401.149",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path",
    fill: "#1F70C1",
    points: "0,373.217 194.433,373.217 194.433,401.05 0,401.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_1_",
    fill: "#1F70C1",
    points: "0,319.83 194.433,319.83 194.433,347.761 0,347.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_2_",
    fill: "#1F70C1",
    points: "55.468,266.541 138.867,266.541 138.867,294.473 55.468,294.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_3_",
    fill: "#1F70C1",
    points: "55.468,213.253 138.867,213.253 138.867,241.185 55.468,241.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_4_",
    fill: "#1F70C1",
    points: "55.468,159.964 138.867,159.964 138.867,187.896 55.468,187.896  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_5_",
    fill: "#1F70C1",
    points: "55.468,106.577 138.867,106.577 138.867,134.509 55.468,134.509  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_6_",
    y: 53.288,
    fill: "#1F70C1",
    width: 194.433,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_7_",
    fill: "#1F70C1",
    width: 194.433,
    height: 27.932
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    fill: "#1F70C1",
    d: "M222.167,347.761h299.029c5.051-8.617,8.815-18.027,11.094-27.932H222.167V347.761z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    fill: "#1F70C1",
    d: "M497.92,213.253H277.734v27.932h243.463C514.857,230.487,507.032,221.078,497.92,213.253z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    fill: "#1F70C1",
    d: "M277.734,159.964v27.932H497.92c9.311-7.825,17.135-17.235,23.277-27.932H277.734z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19_",
    fill: "#1F70C1",
    d: "M521.197,53.288H222.167V81.22H532.29C529.715,71.315,525.951,61.906,521.197,53.288z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20_",
    fill: "#1F70C1",
    d: "M429.279,0H222.167v27.932h278.526C482.072,10.697,456.815,0,429.279,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path_8_",
    x: 277.734,
    y: 106.577,
    fill: "#1F70C1",
    width: 83.3,
    height: 27.932
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_21_",
    fill: "#1F70C1",
    d: "M444.433,134.509h87.163c2.476-8.914,3.764-18.324,3.764-27.932h-90.927L444.433,134.509 L444.433,134.509z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_9_",
    fill: "#1F70C1",
    points: "277.734,266.541 361.034,266.541 361.034,294.473 277.734,294.473  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22_",
    fill: "#1F70C1",
    d: "M444.433,266.541v27.932h90.927c0-9.608-1.288-19.017-3.764-27.932H444.433z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23_",
    fill: "#1F70C1",
    d: "M222.167,400.852l207.112,0.297c27.734,0,52.793-10.697,71.513-27.932H222.167V400.852z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_10_",
    fill: "#1F70C1",
    points: "555.567,373.217 694.433,373.217 694.433,401.05 555.567,401.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_11_",
    fill: "#1F70C1",
    points: "555.567,319.83 694.433,319.83 694.433,347.761 555.567,347.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_12_",
    fill: "#1F70C1",
    points: "611.034,266.541 694.433,266.541 694.433,294.473 611.034,294.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_13_",
    fill: "#1F70C1",
    points: "611.034,213.253 694.433,213.253 694.433,241.185 611.034,241.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_24_",
    fill: "#1F70C1",
    points: "733.063,53.288 555.567,53.288 555.567,81.22 742.67,81.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_25_",
    fill: "#1F70C1",
    points: "714.639,0 555.567,0 555.567,27.932 724.247,27.932  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_14_",
    fill: "#1F70C1",
    points: "861.034,373.217 1000,373.217 1000,401.05 861.034,401.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_15_",
    fill: "#1F70C1",
    points: "861.034,319.83 1000,319.83 1000,347.761 861.034,347.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_16_",
    fill: "#1F70C1",
    points: "861.034,266.541 944.433,266.541 944.433,294.473 861.034,294.473  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-path_17_",
    fill: "#1F70C1",
    points: "861.034,213.253 944.433,213.253 944.433,241.185 861.034,241.185  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_26_",
    fill: "#1F70C1",
    points: "861.034,187.896 944.433,187.896 944.433,159.964 861.034,159.964  861.034,159.964 785.559,159.964 777.734,182.548 769.909,159.964 694.433,159.964 694.433,159.964 611.034,159.964  611.034,187.896 694.433,187.896 694.433,162.242 703.249,187.896 852.219,187.896 861.034,162.242  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_27_",
    fill: "#1F70C1",
    points: "944.433,106.577 803.982,106.577 794.374,134.509 944.433,134.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_28_",
    fill: "#1F70C1",
    points: "840.927,0 831.319,27.932 1000,27.932 1000,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_29_",
    fill: "#1F70C1",
    points: "777.734,400.852 787.341,373.217 768.126,373.217  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_30_",
    fill: "#1F70C1",
    points: "759.311,347.761 796.157,347.761 806.062,319.83 749.505,319.83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_31_",
    fill: "#1F70C1",
    points: "740.59,294.473 814.877,294.473 824.683,266.541 730.784,266.541  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_32_",
    fill: "#1F70C1",
    points: "721.969,241.185 833.597,241.185 843.106,213.253 712.361,213.253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_33_",
    fill: "#1F70C1",
    points: "611.034,134.509 761.093,134.509 751.486,106.577 611.034,106.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape_34_",
    fill: "#1F70C1",
    points: "812.896,81.22 1000,81.22 1000,53.288 822.405,53.288  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmLogo);
export default __webpack_public_path__ + "static/media/IBM_logo.4cfa89b15156769dd1faeb14a8463394.svg";
export { ForwardRef as ReactComponent };